var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developer-score"},[_c('v-chip',{staticClass:"developer-score__chip",attrs:{"color":_vm.scoreColor,"text-color":"white","small":""}},[_vm._v(" "+_vm._s(_vm.score)+"% ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }